import { AngelouCSS, BannerStyleOverrides } from "@newsela/angelou";

import { LangstonContentResponse } from "@/types/models";
import { Banner, customConfigFrom, customCssForFrom } from "./sharedImports";

export interface NoAccessBannerProps {
  title?: string | undefined;
  body?: string | undefined;
  __cssFor?: BannerStyleOverrides<AngelouCSS> | undefined;
  whiteBgColor?: boolean | undefined;
  ctaSection?: any;
  content?: LangstonContentResponse | null | undefined;
}

const NoAccessBanner = ({
  title,
  body,
  __cssFor = {},
  whiteBgColor = false,
  ctaSection,
  content,
}: NoAccessBannerProps) => {
  const subject = content?.page_viewmodel?.subject;
  const customConfig = customConfigFrom({ whiteBgColor, subject });
  const customCssFor = customCssForFrom(__cssFor);

  return (
    <Banner
      {...(title ? { title } : {})}
      {...(body ? { body } : {})}
      bannerType={Banner?.types?.custom}
      customConfig={customConfig}
      __cssFor={customCssFor}
      __renderCtaSection={ctaSection}
    />
  );
};

export default NoAccessBanner;
